"use client";

import { FC, useEffect, useState } from "react";

interface ErrorHandlerProps {
  children: React.ReactNode;
}
const ErrorHandler: FC<ErrorHandlerProps> = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const resetError = () => setHasError(false);
  const ErrorFallback = () => (
    <body>
      <div>
        <h2>Something went wrong.</h2>
        <button onClick={resetError}>Try Again</button>
      </div>
    </body>
  );

  useEffect(() => {
    const handleError = (error: any) => {
      setHasError(true);
      console.error("Caught an error:", error);
    };

    window.onerror = (msg, url, lineNo, columnNo, error) => {
      handleError(error);
      return true;
    };

    window.onunhandledrejection = (event) => {
      handleError(event.reason);
    };

    return () => {
      window.onerror = null;
      window.onunhandledrejection = null;
    };
  }, []);

  if (hasError) {
    // debugger;
    // return <ErrorFallback />;
  }
  return children;
};

export default ErrorHandler;
